import type { Price } from '@montugroup/circuit-shared/types/product';

export const formatPrice = (price: Price) =>
  new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
  }).format(Number(price));

export default {
  formatPrice,
};
